import './CSS/AboutMeTitleStyle.css';
function ParagraphTitleAboutme(props) {
    return (
       <h1 id="aboutMeText">About me</h1>   
    );
  }
  
  export default ParagraphTitleAboutme;
  